const PrevNext = () => {
  const Prev = `<button type="button" class="prv" data-tlarea="DDO0" data-tlord="2" data-role="slidePrev"><span class="blind">이전</span></button>`;
  const Next = `<button type="button" class="nxt" data-tlarea="DDO0" data-tlord="3" data-role="slideNext"><span class="blind">다음</span></button>`;
  return `${Prev}${Next}`;
};

export default PrevNext;
